import { render, staticRenderFns } from "./ColumnasPanel.vue?vue&type=template&id=27192b14&"
import script from "./ColumnasPanel.vue?vue&type=script&lang=js&"
export * from "./ColumnasPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports